import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    nombre: '',
    habilitadoSinPagare: false,
    inactivo: false,
    rowVersion: null,
    
    formaPagoDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_FORMA_PAGO'(state, formaPagoId) {
        state.id = formaPagoId;
        state.nombre = '';
        state.habilitadoSinPagare = false;
        state.inactivo = false;
        state.rowVersion = null;
    },
    'SET_FORMA_PAGO'(state, formaPago) {
        state.nombre = formaPago.nombre.toUpperCase().trim();
        state.habilitadoSinPagare = formaPago.habilitadoSinPagare;
        state.inactivo = formaPago.inactivo;
        state.rowVersion = formaPago.rowVersion;
    },

    'INICIALIZAR_DATOS'(state) {
        state.formaPagoDatos = [];
    },
    'SET_DATOS'(state, formaPagoDatos) {
        state.formaPagoDatos = formaPagoDatos;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, formaPagoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_FORMA_PAGO', formaPagoId);

            if (formaPagoId != 0) {
                apiAxios.get('formaspago/' + formaPagoId + '/abm' ) 
                .then(res => {
                    commit('SET_FORMA_PAGO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        }, error => {
            reject(error);
        })
    },    
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let formaPago= {
                nombre: state.nombre.toUpperCase().trim(),
                habilitadoSinPagare: state.habilitadoSinPagare,
                inactivo: state.inactivo,
            }

            let url = 'formaspago';
            if (state.id != 0) {
                url += '/' + state.id;
                formaPago.rowVersion = state.rowVersion;
            }

            apiAxios.post(url, formaPago)
                .then(() => {
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getDatos ( { commit }, formaPagoId ) {
        return new Promise((resolve, reject) => {

            commit('INICIALIZAR_DATOS');
            
            if (formaPagoId) {
                if (formaPagoId != 0) {
                    apiAxios.get('formaspago/' + formaPagoId ) 
                    .then(res => {
                        let formaPagoDatos = [
                            { 'nombre': 'id', 'campo': 'Cod.', 'valor': res.data.id, 'formato': '' },
                            { 'nombre': 'nombre', 'campo': 'Nombre', 'valor': res.data.nombre, 'formato': '' },
                            { 'nombre': 'habilitadoSinPagare', 'campo': 'Habilitado s/Pagare', 'valor': (res.data.habilitadoSinPagare) ? 'Si' : 'No', 'formato': '' },
                            { 'nombre': 'inactivo', 'campo': 'Inactivo', 'valor': (res.data.inactivo) ? 'Si' : 'No', 'formato': '' },
                        ];
                        commit('SET_DATOS', formaPagoDatos);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
                }
            } 
        }, error => {
            reject(error);
        })            
    },
    inactivar ( {}, formaPagoId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('formaspago/' + formaPagoId + '/inactivar')
                .then(() => {
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}